module.exports = __webpack_public_path__ + "static/img/jiaotongyunshu-1.7301ce12.svg";